import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";
import CopyToClipboard from "react-copy-to-clipboard";

interface Props extends WithStyles<typeof styles> {
	id: number;
	text?: string;
	onHeader?: boolean;
}

interface State {
	clipboard: string
}

class Component extends React.Component<Props, State> {
	public constructor(props: Props) {
		super(props)
		this.state = {
			clipboard: "",
		}
	}

	public render() {
		const { id, text, onHeader = false, classes = {} } = this.props;
		const { clipboard } = this.state;

		return (
			<CopyToClipboard 
				text={`${id}`}
				onCopy={(id) => this.setState({clipboard: id})}
			>
				<Mui.Tooltip title={text && clipboard !== `${id}` ? `${text}` : "Copied!"}>
					<Mui.Button 
						className={!onHeader ? classes.button : classes.buttonOnHeader}
						variant="text"
					>
						{id}
					</Mui.Button>
				</Mui.Tooltip>
			</CopyToClipboard>
		);
	}
}

export const CopyID = withStyles(Component, styles);
